<template>
  <div class="instruction">
    <DisplayText :screenProperties="screenProperties"></DisplayText>
  </div>

  <div class="scan-media">
    <img :src="eidReadImage" alt="scan" id="scan-image">
  </div>

  <div class="warning-orange" id="card_read_message">
    <i class="fa-3x fas fa-spinner fa-pulse" id="processing"></i>
    {{ cardNotFound }}
    <button class="btn" id="tryAgain" @click="recheck" v-show="go!==''"> {{ go }}</button>
  </div>

  <div class="eid-button w3-hide">
    <QppButton :buttons="buttons" :loaded="cardRead"></QppButton>
  </div>
</template>

<script>
import store from "@/store";
import DisplayText from "@/components/common/DisplayText";
import QppButton from "@/components/common/QppButton";
import screenApiService from "@/services/screenApiService";
import zijdeRoute from "@/services/zijderoute"
import screenService from "@/services/screenApiService";
import {mapState} from "vuex";
import helper from "@/services/helper";

const toTranslate = ['cardNotFound', 'go'];

export default {
  name: 'EID_READ',
  components: {DisplayText, QppButton},
  data() {
    return {
      screenProperties: {},
      buttons: [],
      cardRead: false,
      cardNotFound: '',
      startTime: new Date(),
      cardChecked: false,
      cardReadSuccess: false,
      go: '',
      eidReadImage: null,
      cardCheckTimer: null,
      cardRecheckTimer: null,
      cardReadTimer: null,
      visitor: undefined
    }
  },
  computed: mapState(['toggleText']),
  watch: {
    toggleText(newValue) {
      if (store.state.languageId !== store.state.defaultLanguage.id && this.cardNotFound !== '') {
        if (newValue === true) {
          this.getTranslation(store.state.defaultLanguage.id, toTranslate);
        } else if (newValue === false) {
          this.getTranslation(store.state.languageId, toTranslate);
        }
      }
    }
  },
  mounted() {
    this.visitor = store.state.visitor;
    this.buttons = store.state.currentScreenOptions;
    this.screenProperties = store.state.currentScreenProperties;
    store.state.checkForgottenEid = true; //to remind of not forgetting card
    document.getElementById('processing').style.display = 'inline-block';
    document.getElementById('tryAgain').style.display = 'none';
    screenApiService.showPopup();
    zijdeRoute.onLoad();
    this.cardChecked = false;
    this.checkCard();
    let app = this;
    helper.findImage("eidRead.gif").then(function (res) {
      app.eidReadImage = res;
    })
    app.cardCheckTimer = setTimeout(() => {
      if (this.cardChecked === false) {
        store.commit('showError', true);
        store.state.errorStatus = 'CHECK_CARD_FAILED';
      }
    }, 20000);

    // for dividing screen in landscape mode
    document.getElementById('inner').classList.add('landscape-inner');
  },
  beforeUnmount() {
    screenApiService.resetPopup();
    zijdeRoute.offLoad();
    store.commit('showError', false);
    store.state.errorStatus = '';
    clearTimeout(this.cardCheckTimer);
    clearTimeout(this.cardReadTimer);
    document.getElementById('inner').classList.remove('landscape-inner');
  },
  methods: {
    getTranslation(lang = store.state.languageId, keys) {
      let app = this;
      if (lang) {
        keys.forEach(function (key) {
          screenService.getTranslation(lang, 'fe.' + key).then(function (response) {
            app[key] = response.data;
          }).catch(function () {
            console.log("No translation found for fe." + key + " in language " + lang);
            app[key] = '-'
          })
        })
      }
    },
    recheck() {
      clearTimeout(this.cardReadTimer);
      this.reset();
      this.startTime = Date.now();
      this.cardChecked = false;
      this.checkCard();
      this.cardRecheckTimer = setTimeout(() => {
        if (this.cardChecked === false) {
          store.commit('showError', true);
          store.state.errorStatus = 'CHECK_CARD_FAILED';
        }
      }, 20000);
    },
    checkCard() {
      let timeElapsed = (Date.now() - this.startTime) / 1000; //seconds
      if (timeElapsed >= 30) {
        document.getElementById('processing').style.display = 'none';
        document.getElementById('tryAgain').style.display = 'block';
        this.getTranslation(store.state.languageId, toTranslate);
      } else {
        zijdeRoute.checkCard((msg) => {
          this.cardChecked = true;
          if (msg.success === true) {
            let cardPresent = msg.message.CARD_PRESENT;
            if (cardPresent === true) {
              console.log("card present")
              this.cardReadSuccess = false;
              this.readCard();
              this.cardReadTimer = setTimeout(() => {
                if (this.cardReadSuccess === false) {
                  store.commit('showError', true);
                  store.state.errorStatus = 'READ_CARD_FAILED';
                }
              }, 20000);
            } else {
              console.log("card not present")
              this.checkCard()
            }
          } else {
            console.log("Problems with checking card present")
            store.commit('showError', true);
            store.state.errorStatus = 'CHECK_CARD_FAILED';
          }
        });
      }
    },
    readCard() {
      this.reset();
      // document.querySelector("button").disabled = true;
      zijdeRoute.readCard((msg) => {
        if (msg.success === true) {
          this.cardReadSuccess = true;
          this.log(msg);
          this.cardRead = true;
          this.cardNotFound = '';
          this.go = '';
        } else {
          // document.querySelector("button").disabled = false;
          document.getElementById('processing').style.display = 'none';
          document.getElementById('tryAgain').style.display = 'block';
          this.getTranslation(store.state.languageId, toTranslate);
        }
      });
    },

    log(message) {
      console.log("LOGGING ON KIOSK PAGE %o", message);
      this.visitor = message.message;
      store.commit('setVisitorData', message.message);
    },

    reset() {
      this.cardNotFound = "";
      this.go = "";
      document.getElementById('processing').style.display = 'inline-block';
      document.getElementById('tryAgain').style.display = 'none';
    }

  }
}
</script>
